export default `
<section>
  <p>Teil on lubatud taotlust täita vaid juhul, kui teil on õigus teenusepakkujat esindada.
  </p>
  <p>InnoCAPE konsortsium ei vastuta taotluses esitatud teabe õigsuse eest.
  </p>
  <p>EL-siseseid taotlusi menetleb määratud piirkondlik partner, ülejäänusid koordinaator. InnoCAPE konsortsium
    otsustab, millised tarnijad lisatakse Kompetentsikaardi andmebaasi. Konsortsium jätab endale õiguse taotlus tagasi
    lükata või juba kinnitatud teenusepakkuja nimekirjast ajutiselt või jäädavalt tagasiside või auditeerimise põhjal
    eemaldada. Kõiki muudatusi pärast taotluse esitamist teeb piirkondlik partner teenusepakkuja palvel, et parandada
    teavet usaldusväärse allika põhjal või muuta sisu teenusesõbralikumaks.
  </p>
  <p>InnoCAPE konsortsium ei võta teenusepakkujalt tasu ei taotlusprotsessi ega Kompetentsikaardi nimekirja kandmise
    eest, kuid ei anna ka mingit garantiid selle kohta, kui palju süsteem teenusepakkujale nähtavust pakub. Seda kõike
    juhivad kasutajate kasutatavad otsinguterminid ja otsingu algoritm. Süsteem saadab pakkujale igakuise aruande
    saavutatud nähtavuse kohta.
  </p>
  <p>InnoCAPE konsortsium jätab endale õiguse kasutada süsteemi, teenusepakkujate ja kasutamise käigus genereeritud
    andmeid digitaliseerimise olukorra ja vajaduste kajastamiseks ja analüüsimiseks.
  </p>
  <p>Kui teil on küsimusi Kompetentsikaardi, taotlusprotsessi või muu kohta, võtke lisateabe saamiseks ühendust oma
    lähima
    <a target="_blank" href="https://dma.innocape.eu/en/contacts" rel="noopener noreferrer">projektipartneriga
    </a>.
  </p>
</section>
`
